import './style.scss';

// TextImage Component JavaScript

document.addEventListener('DOMContentLoaded', function() {

});
